<template>
  <div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{ $t("common.name") }}</label>
        <input
          type="text"
          v-model="localData.name"
          :placeholder="$t('common.name')"
          :class="{ 'field-error': $v.localData.name.$error }"
          class="form-control"
          @input="emitData"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.legal_form")
        }}</label>
        <b-form-select
          v-model="localData.legal_form"
          class="form-control"
          :class="{ 'field-error': $v.localData.legal_form.$error }"
          :options="partner_legal_forms_list"
          @input="emitData"
        ></b-form-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("common.type")
        }}</label>
        <b-form-select
          v-model="localData.partner_type"
          class="form-control"
          :options="partner_type_list"
          @input="emitData"
        ></b-form-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-12 col-lg-8 mt-4">
        <label class="control-label mb-2">{{ $t("common.active") }}</label>
        <Toggle
          :is-active="isActive"
          :on-change="onIsActiveChanged"
          :has-toggle-text="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import required from "vuelidate/lib/validators/required";
import { buildDropdownOptions } from "~/helpers/common";
import { mapActions, mapGetters } from "vuex";
import Toggle from "@/components/Toggle.vue";

export default {
  name: "PartnerGeneralData",
  components: {
    Toggle,
  },
  props: {
    data: {
      type: Object,
    },
    title: {
      type: String,
      default() {
        return this.$t("stock_management.partners.create_new");
      },
    },
  },
  data() {
    return {
      partner_legal_forms: this.partnerLegalForms ? this.partnerLegalForms : [],
      partner_types: this.partnerTypes ? this.partnerTypes : [],
      localData: { ...this.data }, // Create a local copy of data
    };
  },
  computed: {
    ...mapGetters({
      partnerTypes: "smPartners/smPartnerTypes",
      partnerLegalForms: "smPartners/smPartnerLegalForms",
    }),
    partner_legal_forms_list() {
      let vm = this;
      return buildDropdownOptions(
        Object.keys(this.partnerLegalForms).map((key) => {
          return vm.partnerLegalForms[key];
        }),
        {
          value: "uuid",
          text: "name",
        },
        {
          value: null,
          text: "-",
        }
      );
    },
    partner_type_list() {
      let vm = this;
      return buildDropdownOptions(
        Object.keys(this.partnerTypes).map((key) => {
          return vm.partnerTypes[key];
        }),
        {
          value: "uuid",
          text: "name",
        },
        {
          value: null,
          text: "-",
        }
      );
    },
    validator() {
      return this.$v;
    },
    isActive() {
      return parseInt(this.localData?.is_active, 10) === 1;
    },
  },
  methods: {
    ...mapActions({
      getPartnerTypes: "smPartners/getSmPartnerTypes",
      getPartnerLegalForms: "smPartners/getSmPartnerLegalForms",
    }),
    onIsActiveChanged(val) {
      this.localData.is_active = val ? 1 : 0;
      this.emitData();
    },
    emitData() {
      this.$emit("update-partner-data", { ...this.localData }, 1);
    },
    validate() {
      this.$v.localData.$touch();
      return !this.$v.localData.$invalid;
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        console.log("updateData step 1 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
  },
  mounted() {
    this.getPartnerLegalForms();
    this.getPartnerTypes();
  },
  watch: {
    partnerLegalForms: {
      handler: function (newVal) {
        this.partner_legal_forms = Object.keys(newVal).map((key) => {
          return newVal[key];
        });
      },
      deep: true,
    },
    partnerTypes: {
      handler: function (newVal) {
        this.partner_types = Object.keys(newVal).map((key) => {
          return newVal[key];
        });
      },
      deep: true,
    },
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-partner-data", { ...newData }, 1);
      },
    },
  },
  validations() {
    return {
      localData: {
        name: {
          required,
        },
        legal_form: {
          required,
        },
      },
    };
  },
};
</script>
